<script async setup>
import { defineProps, ref, watch } from "vue";

const props = defineProps({
    id: {
        type: String,
        default: "",
    },
    title: {
        type: String,
        required: true,
    },
    groupName: {
        type: String,
        default: "",
    },
    groupId: {
        type: String,
        default: "",
    },
    open: {
        type: Boolean,
        default: false,
    },
    count: {
        type: String,
        default: "0",
    },
    showGroupName: {
        type: Boolean,
        default: true
    }
});
const isOpen = ref(!!props.open);

watch(
    () => props.open,
    (v) => {
        isOpen.value = !!v;
    }
);

const emit = defineEmits(["toggle"]);

const onHeaderClick = () => {
    isOpen.value = !isOpen.value;
    emit("toggle", isOpen.value);
};
</script>

<template>
    <div
        v-if="props.showGroupName && props.groupName && props.count >= 5"
        :id="props.groupId"
        class="flex items-center gap-4 mt-6"
    >
        <span class="text-md mini:text-lg font-bold text-black underline underline-offset-2">
            {{ props.groupName }}
        </span>
    </div>

    <div class="w-full border-b-2 border-black">
        <button
            type="button"
            :id="props.id"
            class="w-full list-none flex justify-between gap-4 items-center py-3 cursor-pointer"
            @click="onHeaderClick"
        >
            <span class="text-sm mini:text-base font-bold text-left">
                {{ props.title }}
            </span>

            <span
                class="flex items-center justify-center transition-transform duration-300 ease-in-out"
                :class="isOpen ? 'rotate-180' : 'rotate-0'"
            >
                <kd-icon-plus v-if="!isOpen" fill="black" size="30" />
                <kd-icon-minus v-else fill="black" size="30" />
            </span>
        </button>
        <div
            :class="[
                'text-sm mini:text-base max-w-[90%] overflow-hidden transition-all duration-300 ease-in-out',
                isOpen
                    ? 'opacity-100 translate-y-0 max-h-screen pb-4'
                    : 'opacity-0 -translate-y-1 max-h-0 pb-0'
            ]"
        >
            <slot />
        </div>
    </div>
</template>
